import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/family-smiling-1250-900.jpg'


const _hoisted_1 = {
  key: 0,
  class: "row head-image-overlay grey-background-color dark-text-color"
}
const _hoisted_2 = {
  class: "col col-12 col-lg-6 d-flex align-items-center ps-4 pe-5 pt-4",
  style: {"padding-left":"120px !important"}
}
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = {
  class: "small pb-2",
  style: {"letter-spacing":"2px","text-transform":"uppercase"}
}
const _hoisted_5 = {
  key: 1,
  class: "row d-lg-none d-flex grey-background-color dark-text-color"
}
const _hoisted_6 = { class: "col col-12 ps-4 pe-5 pt-4" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  class: "small pb-2",
  style: {"letter-spacing":"2px","text-transform":"capitalize"}
}
const _hoisted_9 = { class: "col col-12 px-0" }
const _hoisted_10 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isMobile())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString($props.pageDescription), 1),
            _renderSlot(_ctx.$slots, "bannerHTMLLarge", {}, undefined, true)
          ])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col col-12 col-lg-6" }, [
          _createElementVNode("div", { class: "d-flex justify-content-right" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "head-image image-mask",
              alt: "A smiling family"
            })
          ])
        ], -1))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString($props.pageDescription), 1),
            _renderSlot(_ctx.$slots, "bannerHTMLMobile", {}, undefined, true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: require(`@/assets/${$props.image}`),
            class: "head-image image-mask mh-100",
            alt: $data.imgAlt
          }, null, 8, _hoisted_10)
        ])
      ]))
}